export default function numericalMask(value: string): string {
    let newValue = value
    if (!newValue) return ''

    newValue = newValue.replace(/\D*/g, '')
    if (newValue.length > 6) newValue = newValue.slice(0, 6)

    return newValue
}
